import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import { backendApis } from "../config";
import { useAuth } from "../hooks/useAuth";
import { searchParamsToObject } from "../utils/helpers";
import { useEffectOnce } from "../utils/hooks";
import ModalLoader from "./utils/ModalLoader";

export default function Authorize() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const location = useLocation();

  const auth = async () => {
    let url = new URL(document.location.href);
    console.log(url)
    console.log(url.origin)
    const { token } = searchParamsToObject(
      url.searchParams.entries()
    );

    console.log(token)

    //TODO - secure unique key
    const loginResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-email`, {
      method: "POST",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      body: JSON.stringify({ token: token }),
      credentials: "include",
    });

    // await loginResponse.json()
    const { success, message, redirect } = await loginResponse.json()
    if (!success) {
      toast.error(message);
    } else {
      // const company = backendApis.find(el => el.url === route)
      // login({ ...user, company: company.name });
      window.location.href = redirect
      //navigate(redirect, { replace: true });
    }
  }

  useEffectOnce(() => {
    auth();
  });

  return <ModalLoader show={true} />;
}
